import { OptionsList } from "@babackapp/customer-ui/components/option";
import { RadioGroup } from "@babackapp/customer-ui/components/radio-group";
import type { ResolutionOption } from "@babackapp/return-widget-components/types";
import { BankTransferOption } from "./bank-transfer-option";
import { DiscountOption } from "./discount-option";

type Props = {
  value: ResolutionOption | null;
  onChange: (value: ResolutionOption) => void;
  discountAvailable?: boolean;
  refundAvailable?: boolean;
};

export function RefundOptions({
  value,
  onChange,
  discountAvailable = true,
  refundAvailable = true,
}: Props) {
  return (
    <OptionsList>
      <RadioGroup
        value={value ?? ""}
        onValueChange={(v) => onChange(v as ResolutionOption)}
      >
        {refundAvailable && (
          <BankTransferOption
            selected={value === "bank-transfer"}
            discountAvailable={discountAvailable}
          />
        )}
        {discountAvailable && <DiscountOption />}
      </RadioGroup>
    </OptionsList>
  );
}
